/** Постоянный ключ позволяет сохранить доставку при смене вида строк заказа. */
export const DELIVERY_ITEM_ID = 'clinic-delivery';
/** Доставка — самостоятельная позиция документа, а не прибавка к цене заказов. */
export function clinicDeliveryItems(clinic) {
    if (!clinic?.countDelivery)
        return [];
    return [{ id: DELIVERY_ITEM_ID, name: 'Доставка', qty: 1, unit: 'усл.', priceKop: clinic.deliveryKop ?? 0 }];
}
/** Вторая строка в счёте и акте. Сохранённая ручная правка доставки не теряется. */
export function withInvoiceDelivery(items, delivery) {
    const работы = items.filter((item) => item.id !== DELIVERY_ITEM_ID);
    const строка = delivery.find((item) => item.id === DELIVERY_ITEM_ID);
    return строка ? [...работы.slice(0, 1), строка, ...работы.slice(1)] : работы;
}
//# sourceMappingURL=invoice-delivery.js.map